<div>
    <div>
        <ion-label class="ts-caption-bold ts-body text-neutral-400">{{ label }}</ion-label>
    </div>
    <div [ngStyle]="{height: valueHeight ? valueHeight + 'px': ''}"
         [class.overflow-auto]="valueHeight > 0">

        <div [class.app-border-text-box]="valueHeight"
             #valueElement>
            <div class="ts-caption" [innerHTML]="value"></div>
        </div>

    </div>
</div>
